import React, { useState } from 'react';
import { Button } from '../../UI/Buttons';
import { Text } from '../../UI/Typography';
import Table from '../../UI/Table';
import ConfirmationModal from './ConfirmationModal';
import { deleteSite } from '../../../Services/Api/siteService';
import { FaMapMarkedAlt, FaTrashAlt, FaSpinner } from 'react-icons/fa';

const SiteTable = ({ sites, isLoading, error, onViewBoundary, onRefresh }) => {
  const [deletingSiteId, setDeletingSiteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);

  const handleDeleteClick = (siteId, siteName) => {
    setSelectedSite({ id: siteId, name: siteName });
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedSite) return;
    
    setShowDeleteModal(false);
    setDeletingSiteId(selectedSite.id);
    
    try {
      await deleteSite(selectedSite.id);
      if (onRefresh) onRefresh();
    } catch (error) {
      alert(`Error deleting site: ${error.message}`);
    } finally {
      setDeletingSiteId(null);
      setSelectedSite(null);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedSite(null);
  };

  const columns = [
    { key: 'id', label: 'ID', align: 'left' },
    { key: 'name', label: 'Name', align: 'left' },
    {
      key: 'actions',
      label: 'Actions',
      align: 'center',
      width: '140px'
    }
  ];

  const renderCell = (item, column) => {
    if (column.key === 'actions') {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button
            title={`View boundary for ${item.name}`}
            onClick={() => onViewBoundary(item)}
            disabled={deletingSiteId === item.id}
            variant="ghost"
            size="small"
          >
            <FaMapMarkedAlt />
          </Button>
          <Button
            title={`Delete site ${item.name}`}
            onClick={() => handleDeleteClick(item.id, item.name)}
            disabled={deletingSiteId === item.id}
            variant="ghost"
            size="small"
            color="error"
          >
            {deletingSiteId === item.id ? <FaSpinner className="spin" /> : <FaTrashAlt />}
          </Button>
        </div>
      );
    }
    return item[column.key];
  };

  return (
    <>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <Table
          columns={columns}
          data={sites}
          renderCell={renderCell}
          isLoading={isLoading}
          error={error}
          emptyState={
            <Text style={{ padding: '2rem', textAlign: 'center' }}>
              No sites found.
            </Text>
          }
        />
      </div>

      <ConfirmationModal
        isOpen={showDeleteModal}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        title="Delete Site"
        message={`Are you sure you want to delete "${selectedSite?.name}"?`}
        confirmText="Delete"
        cancelText="Cancel"
        confirmVariant="danger"
      />
    </>
  );
};

export default SiteTable;
